var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.893799H513V342.86H0V0.893799Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.927H513V257.394H0V171.927Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 257.394H513V342.86H0V257.394Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 231.443C289.37 231.443 316.016 204.797 316.016 171.927C316.016 139.057 289.37 112.411 256.5 112.411C223.63 112.411 196.984 139.057 196.984 171.927C196.984 204.797 223.63 231.443 256.5 231.443Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.921 80.9498C369.921 80.9498 342.668 67.1229 335.955 64.9186C329.242 62.7143 286.759 51.6928 286.759 57.9049C286.759 68.225 273.233 69.9283 271.229 69.9283C269.225 69.9283 269.225 64.618 256.4 64.618C243.575 64.618 242.673 69.4274 240.569 69.4274C238.365 69.4274 226.041 68.4254 226.041 57.9049C226.041 52.6947 183.057 61.9127 176.845 64.9186C170.733 68.0246 142.879 80.9498 142.879 80.9498C142.879 80.9498 188.768 83.6551 196.884 87.1619C205 90.6688 240.769 103.694 240.769 103.694L237.964 117.02H275.838L272.03 103.694C272.03 103.694 307.199 90.9693 315.916 87.1619C324.633 83.3545 369.921 80.9498 369.921 80.9498Z",
    fill: "#4C1F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.125 172.929C218.125 194.07 235.359 211.304 256.5 211.304C277.641 211.304 294.875 194.07 294.875 172.929V161.407H218.225V172.929H218.125Z",
    fill: "#57BA17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 111.61C235.359 111.61 218.125 128.843 218.125 149.984V161.507H294.775V149.984C294.875 128.843 277.641 111.61 256.5 111.61Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.893799)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/EC.743d8f6b1c61c5127a955b22fe44e306.svg";
export { ForwardRef as ReactComponent };